import useSearchParams from './useSearchParams.js';
import {useCallback} from 'react';

export default function () {
  const {searchParams, setSearchParams} = useSearchParams();

  const collectionId = searchParams.get('collection');

  const setCollection = useCallback(
    id => {
      searchParams.set('collection', id);

      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  const resetCollection = useCallback(() => {
    searchParams.delete('collection');
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return {collectionId, setCollection, resetCollection};
}
